const driverActionTypes = {
    START_GET_DRIVERS_LIST: 'START_GET_DRIVERS_LIST',
    GET_DRIVERS_LIST_SUCCESS: 'GET_DRIVERS_LIST_SUCCESS',
    GET_DRIVERS_LIST_FAILURE: 'GET_DRIVERS_LIST_FAILURE',

    START_ADD_DRIVER: 'START_ADD_DRIVER',
    ADD_DRIVER_SUCCESS: 'ADD_DRIVER_SUCCESS',
    ADD_DRIVER_FAILURE: 'ADD_DRIVER_FAILURE',

    START_EDIT_DRIVER: 'START_EDIT_DRIVER',
    EDIT_DRIVER_SUCCESS: 'EDIT_DRIVER_SUCCESS',
    EDIT_DRIVER_FAILURE: 'EDIT_DRIVER_FAILURE',
   
    START_DELETE_DRIVER: 'START_DELETE_DRIVER',
    DELETE_DRIVER_SUCCESS: 'DELETE_DRIVER_SUCCESS',
    DELETE_DRIVER_FAILURE: 'DELETE_DRIVER_FAILURE',

    START_EDIT_PERMISSIONS: 'START_EDIT_PERMISSIONS',
    EDIT_PERMISSIONS_SUCCESS: 'EDIT_PERMISSIONS_SUCCESS',
    EDIT_PERMISSIONS_FAILURE: 'EDIT_PERMISSIONS_FAILURE',
}

export default driverActionTypes;